"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.beamswap = void 0;
exports.beamswap = {
    router: '0x96b244391D98B62D19aE89b1A4dCcf0fc56970C7',
    masterchef: '0xC6ca172FC8BDB803c5e12731109744fb0200587b',
};
